export const NotificationTemplateColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "messageTemplate", 
    headerName: "Message Template", 
    flex: 2,
    valueGetter: (params) => params.row.messageTemplate || "-", 
  },
  { field: "notificationType", headerName: "Notification Type", flex: 1 },
];

export const AllEmailTemplatesColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "messageTemplate", 
    headerName: "Message Template", 
    flex: 2, 
    valueGetter: (params) => params.row.messageTemplate || "-",
  },
];

export const AllSmsTemplateColumn = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "messageTemplate", 
    headerName: "Message Template", 
    flex: 2, 
    valueGetter: (params) => params.row.messageTemplate || "-",
  },
  { field: "status", headerName: "Status", flex: 1 },
];

export const EmployeePaymentTypesColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "paymentType", headerName: "Payment Type", flex: 1 },
];
